var userLang = navigator.language || navigator.userLanguage; 
export const language = userLang === 'nl-NL' ? require('./nl_NL.json') : require('./en_US.json');